import MasterService from '../services/MasterService';

interface travelLeadListRequest {
    page_number?: number;
    limit?: number;
    status_type?: string;
    from_date?: string;
    to_date?: string;
    datetype?: string;
    searchKey?: string;
    sort?: string;
    lead_id?: number;
}
interface travelPlanListRequest {
    page_number?: number;
    limit?: number;
    sort_by?: "ASC" | "DSC";
    traveller_count:number,
    trip_start_date:string,
    trip_end_date:string,
    insurance_type: number,
    trip_type: number,
    origin_country_id: number,
    dest_country_id: number,
    insured?: { dob: string }[]
}
interface createTravelLeadRequest {
    [key: string]: any;
}
interface travelLeadDetailsRequest {
    lead_id: number;
}
interface generateTravelQrCodeRequest {
    lead_id: number;
}
interface uploadTravelLeadDocumentRequest {
    lead_id: string | number;
    upload_type?: string;
    images: File;
}

export const TravelService = {
    ...MasterService,

    
    travelLeadList(params: travelLeadListRequest) {
      return this.post('/travel/lead/travelLeadList', params)
    },

    getTravelFormConfig() {
      return this.post('/travel/form/get-form', { form_name: "travel_lead_form" })
    },

    getTravelCommonConfig() {
      return this.get('/travel/common/config')
    },

    createTravelLead(params: createTravelLeadRequest) {
      return this.post('/travel/lead/createLead', params)
    },

    uploadTravelLeadDocument(params: uploadTravelLeadDocumentRequest) {
      const formData = new FormData();
      // formData.append('upload_type', params.upload_type || 'insurance_ph_docs');
      formData.append('images', params.images);
      // formData.append('upload_doc_type', 'insurance_ph_docs');
      // formData.append('sub_folder', 'sample_file');

      return this.post('/travel/lead/docs_upload', formData)
    },

    travelLeadDetails(params: travelLeadDetailsRequest) {
      return this.post('/travel/lead/travelLeadDetails', params)
    },

    generateTravelQrCode(params: generateTravelQrCodeRequest) {
      return this.post('/travel/lead/generateQrCode', params)
    },

    travelPlanList(params: travelPlanListRequest) {
      return this.post('/travel/quotation/planList', params)
    },

}
